
export const bulkActionsEntryModalHelper = {
  generating_template: '',
  awaiting_file: 'Baixe o arquivo do template, preencha com as informações e faça a importação.',
  with_failure: 'Faça as correções necessárias no seu arquivo.',
  processing: 'Aguarde o processo de análise e interpretação do seu arquivo.',
  awaiting_confirmation: 'Confirme o processo de importação de dados em massa ou envie um novo arquivo.',
  completing: 'Confirme o processo de importação de dados em massa ou envie um novo arquivo.',
  completed: ' finalizado com sucesso!',
};
